import React from "react"
import { NewPersonForm } from '../NewPersonForm.jsx';
import { NewCompanyForm } from '../NewCompanyForm.jsx';
import { ErrorMessage } from '../../shared/ErrorMessage.jsx';
import I18n from 'i18n-js';
import '../../translations.js';

export class NewPersonOrCompany extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div>
        { this.props.type == "person" ? 
          <h1>{I18n.t("activerecord.attributes.user.new_person")}</h1> :
          <h1>{I18n.t("activerecord.attributes.company.new")}</h1>
        }
        <div className="row">
          <div className="span12">
            <p id="warningMessage" />
            { this.props.type == "person" ? 
              <NewPersonForm people={this.props.createUserData.people}
                         provincess={this.props.createUserData.provincess}
                         registrant={this.props.createUserData.registrant}
                         type={this.props.type}
                         userData={this.props.userData}
                         usef={this.props.usef}
                         ec={this.props.ec}
                         fei={this.props.fei} />
              :
              <NewCompanyForm provincess={this.props.createUserData.provincess}
                         registrant={this.props.createUserData.registrant}
                         type={this.props.type}
                         userData={this.props.userData}
                         usef={this.props.usef}
                         ec={this.props.ec}
                         fei={this.props.fei} />
            }
          </div>
        </div>
        <p>
          <b>{ I18n.t("mandatory_field") }</b>
        </p>
        <ErrorMessage message={ "When you press the Create button, you will be sent an email to validate your email address. Click on the link in the email to activate your account." } />
      </div>
    );
  }
}